/* ═══════════════════════════════════════════════════════════
   NOVALYXLABS — nvx-ajax.js v7 — Version finale unifiée
═══════════════════════════════════════════════════════════ */

/* ── VARIANTS MAP ── */
var NVX_VARIANTS = {
  ghkcu:56275652215124,    ghkcu100:56508759540052,
  mt1:56275652575572,      klow:56275652673876,
  kpv10:57301620752724,    amino10:57301628191060,
  tbbpc10:57301633433940,
  sel:56310595944788,      motsc:56508759638356,
  tes5:56508760588628,     ahkcu:56508759671124,
  semax:56310631432532,    ghrp6:56508759736660,
  eb10:56275654312276,     eb3:56275654345044,
  srg3:56508699410772,      sr05:56508699443540,
  sr1:57015751377236,
  kitghk:56508759408980,   kitklw:56508759474516,
  kitghk100:56527214182740,
  kit5:57832781087060,     kit10:57832784494932,
  kit20:57832785346900,    kit30:57832785936724,
  s5:57832789934420,       s10:57832790393172,
  s20:57832790655316,      s30:57832790884692,
  cjcipa10:56949363114324,
  nad500:56949362426196,
  motsc20:57034366484820
};

/* ── AJAX ── */
async function ajaxCart(method,url,body){
  try{
    var o={method:method,credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'}};
    if(body)o.body=JSON.stringify(body);
    var r=await fetch(url,o);
    if(!r.ok)throw new Error(r.status);
    return await r.json();
  }catch(e){console.warn('[NVX]',e.message);return null;}
}
async function fetchCart(){return ajaxCart('GET','/cart.js');}
async function cartAdd(id,qty){return ajaxCart('POST','/cart/add.js',{items:[{id:id,quantity:qty||1}]});}
async function cartChange(key,qty){return ajaxCart('POST','/cart/change.js',{id:key,quantity:qty});}

/* ── ADD TO CART ── */
async function addCart(name,price,id,btn){
  var vid=NVX_VARIANTS[id];
  if(!vid){toast('Produit introuvable');return;}
  if(btn){btn.textContent='...';btn.disabled=true;}
  var r=await cartAdd(vid,1);
  if(btn){btn.textContent='Ajouter';btn.disabled=false;}
  if(r){
    toastCart('✓ '+name+' ajouté au panier');
    trackAddToCart(name,price);
    var c=await fetchCart();
    if(c)renderCart(c);
  }else{
    await new Promise(function(res){setTimeout(res,500);});
    var r2=await cartAdd(vid,1);
    if(r2){toastCart('✓ '+name+' ajouté !');trackAddToCart(name,price);var c2=await fetchCart();if(c2)renderCart(c2);}
    else toast('Erreur — réessayez');
  }
}
function trackAddToCart(name,price){
  try{
    if(typeof fbq==='function')fbq('track','AddToCart',{content_name:name,value:price,currency:'EUR'});
    if(typeof gtag==='function')gtag('event','add_to_cart',{currency:'EUR',value:price,items:[{item_name:name,price:price}]});
  }catch(e){}
}

/* ── RENDER CART ── */
function renderCart(cart){
  var bd=document.getElementById('cartBody');
  var ft=document.getElementById('cartFoot');
  var em=document.getElementById('cartEmpty');
  if(!bd)return;
  bd.querySelectorAll('.cart-it').forEach(function(e){e.remove();});
  var items=cart.items||[];
  var total=(cart.total_price||0)/100;
  var sub=(cart.items_subtotal_price||0)/100;
  var bdg=document.getElementById('cartBdg');
  if(bdg)bdg.textContent=cart.item_count||0;
  if(!items.length){
    if(em)em.style.display='flex';
    if(ft)ft.style.display='none';
    var oldXsell=document.getElementById('cartXsell');
    if(oldXsell)oldXsell.remove();
    return;
  }
  if(em)em.style.display='none';
  if(ft)ft.style.display='flex';
  items.forEach(function(item){
    var lt=(item.line_price||0)/100;
    var img=item.image||'';
    var vt=(item.variant_title&&item.variant_title!=='Default Title')?item.variant_title:'';
    var el=document.createElement('div');
    el.className='cart-it';
    el.innerHTML='<div class="ci-th">'+(img?'<img src="'+img+'" style="width:58px;height:58px;object-fit:cover;border-radius:5px">':'<svg width="38" height="38" viewBox="0 0 38 48"><rect x="7" y="6" width="24" height="34" rx="3" fill="#0D1A28" stroke="#00D4FF" stroke-width=".6" opacity=".5"/><text x="19" y="27" text-anchor="middle" font-family="Arial" font-size="4" fill="#00D4FF" font-weight="700">NVX</text></svg>')+'</div><div style="flex:1;min-width:0"><div class="ci-n">'+item.product_title+'</div>'+(vt?'<div class="ci-v">'+vt+'</div>':'')+'<div class="ci-qty"><button class="q-btn" onclick="apiChgQty(\''+item.key+'\','+(item.quantity-1)+')">−</button><span class="q-n">'+item.quantity+'</span><button class="q-btn" onclick="apiChgQty(\''+item.key+'\','+(item.quantity+1)+')">+</button></div></div><div style="display:flex;flex-direction:column;align-items:flex-end;gap:5px"><span class="ci-price">'+lt.toFixed(2).replace('.',',')+' €</span><button class="ci-del" onclick="apiRemoveLine(\''+item.key+'\')"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 01-2 2H7a2 2 0 01-2-2V6m3 0V4a1 1 0 011-1h4a1 1 0 011 1v2"/></svg></button></div>';
    bd.appendChild(el);
  });
  var se=document.getElementById('subT');if(se)se.textContent=sub.toFixed(2).replace('.',',')+' €';
  var te=document.getElementById('totalV');if(te)te.textContent=total.toFixed(2).replace('.',',')+' €';
  var dr=document.getElementById('discRow');
  if(dr){
    if(cart.cart_level_discount_applications&&cart.cart_level_discount_applications.length){
      dr.style.display='flex';
      var _da=cart.cart_level_discount_applications[0]||{};var _dn=_da.title||_da.code||_da.discount_code||'';var dv=document.getElementById('discVal');if(dv)dv.textContent=(_dn?_dn+' appliqué ✓':'Réduction appliquée ✓');
    }else dr.style.display='none';
  }
  renderCartXsell(items);
}

/* ── CART CROSS-SELL (eau/seringues manquantes) ── */
var CART_XSELL_PEPTIDE_HANDLES=['ghk-cu-50-mg','ghk-cu-100-mg','melanotan-i-10-mg','klow-blend-80-mg','selank-10-mg','mots-c-20-mg','tesamorelin-5-mg','ahk-cu-50-mg','semax-10-mg','ghrp-6-acetate-5-mg','cjc-1295-no-dac-ipamorelin-10-mg','nad-500-mg'];
/* Products listed here need a 1ml reconstitution syringe, everything else needs 3ml — pick the size that matches what's actually in the cart instead of always suggesting 3ml. */
var CART_XSELL_1ML_HANDLES=[];
function renderCartXsell(items){
  var old=document.getElementById('cartXsell');
  if(old)old.remove();
  var peptideItems=items.filter(function(it){return CART_XSELL_PEPTIDE_HANDLES.indexOf(it.handle)>-1;});
  if(!peptideItems.length)return;
  var hasWater=items.some(function(it){return it.handle==='eau-bacteriostatique';});
  var hasSyringe=items.some(function(it){return it.handle==='seringues-1'||it.handle==='seringues';});
  if(hasWater&&hasSyringe)return;
  var needsOnly1ml=peptideItems.every(function(it){return CART_XSELL_1ML_HANDLES.indexOf(it.handle)>-1;});
  var missing=[];
  if(!hasWater)missing.push({name:'Eau Bactériostatique 3ml',id:'eb3',price:7.99});
  if(!hasSyringe){
    if(needsOnly1ml)missing.push({name:'Seringues 1ml',id:'sr1',price:0.99});
    else missing.push({name:'Seringues Reconstitution 3ml',id:'srg3',price:1.98});
    missing.push({name:'Seringues 0,5ml',id:'sr05',price:0.50});
  }
  if(!missing.length)return;
  var bd=document.getElementById('cartBody');
  if(!bd)return;
  var box=document.createElement('div');
  box.id='cartXsell';
  box.style.cssText='background:rgba(0,183,255,.06);border:1px solid rgba(0,183,255,.18);border-radius:8px;padding:10px 12px;margin:4px 0 8px;font-size:11px;color:var(--m2)';
  var html='<div style="font-weight:700;color:#0095FF;margin-bottom:6px">💡 Pensez à compléter votre commande</div>';
  missing.forEach(function(m){
    var safeName=m.name.split("'").join("\\'");
    html+='<div style="display:flex;justify-content:space-between;align-items:center;gap:8px;padding:5px 0;border-top:1px solid rgba(18,21,31,.08)">'+
      '<span>'+m.name+' — '+m.price.toFixed(2).replace('.',',')+' €</span>'+
      '<button onclick="addCart(\''+safeName+'\','+m.price+',\''+m.id+'\',this)" style="background:transparent;border:1px solid rgba(0,212,255,.4);color:#0095FF;font-size:10px;font-weight:700;padding:5px 10px;border-radius:5px;cursor:pointer;white-space:nowrap">+ Ajouter</button>'+
    '</div>';
  });
  box.innerHTML=html;
  bd.appendChild(box);
}
async function apiChgQty(key,qty){var c=await cartChange(key,Math.max(0,qty));if(c)renderCart(c);}
async function apiRemoveLine(key){var c=await cartChange(key,0);if(c)renderCart(c);}
async function applyPromo(btn){var inp=document.getElementById('promoInp');var code=inp?inp.value.trim():'';if(!code)return;var orig=btn?btn.textContent:'';if(btn){btn.textContent='...';btn.disabled=true;}var c=await ajaxCart('POST','/cart/update.js',{discount:code});if(btn){btn.textContent=orig;btn.disabled=false;}if(!c){toast('Erreur — réessayez');return;}renderCart(c);if(c.cart_level_discount_applications&&c.cart_level_discount_applications.length){toast('✓ Code '+code+' appliqué !');if(inp)inp.value='';}else{toast('Code invalide ou expiré');}}
/* ── Questionnaire d'accès (rendu par snippets/nvx-gate.liquid) + confirmation avant de commander ── */
var _NVX_GATE_T={
  fr:{"e":"Accès réservé","et":"Réservé à la recherche en laboratoire","ei":"Merci de lire et de confirmer les points suivants pour accéder au site.","eok":"Accéder au site","eno":"Quitter","ce":"Confirmation","t":"Confirmation avant de commander","i":"Rappel : les produits NOVALYXLABS sont réservés exclusivement à la recherche en laboratoire.","w1":"Usage recherche uniquement","w2":"Ces produits ne sont pas destinés à la consommation humaine ou animale, ni à un usage médical, thérapeutique ou diagnostique.","c1":"Je confirme avoir <strong>18 ans ou plus</strong>.","c2":"Je comprends que ces produits sont destinés <strong>exclusivement à la recherche en laboratoire</strong> et qu'ils <strong>ne doivent en aucun cas être consommés</strong> par l'homme ou l'animal, ni utilisés à des fins médicales ou diagnostiques.","c3":"Je suis responsable de leur manipulation et du respect de la réglementation qui m'est applicable.","ok":"Confirmer et continuer","no":"Annuler","f":"Votre confirmation est horodatée et enregistrée avec votre commande. Elle vous sera redemandée à chaque nouvelle visite."},
  en:{"e":"Restricted access","et":"For laboratory research only","ei":"Please read and confirm the following to access the site.","eok":"Enter the site","eno":"Leave","ce":"Confirmation","t":"Confirmation before ordering","i":"Reminder: NOVALYXLABS products are reserved exclusively for laboratory research.","w1":"Research use only","w2":"These products are not intended for human or animal consumption, nor for medical, therapeutic or diagnostic use.","c1":"I confirm that I am <strong>18 years of age or older</strong>.","c2":"I understand that these products are intended <strong>exclusively for laboratory research</strong> and must <strong>never be consumed</strong> by humans or animals, nor used for medical or diagnostic purposes.","c3":"I am responsible for their handling and for complying with the regulations that apply to me.","ok":"Confirm and continue","no":"Cancel","f":"Your confirmation is time-stamped and saved with your order. You will be asked again on each new visit."},
  de:{"e":"Eingeschränkter Zugang","et":"Nur für die Laborforschung","ei":"Bitte lesen und bestätigen Sie die folgenden Punkte, um die Website zu betreten.","eok":"Website betreten","eno":"Verlassen","ce":"Bestätigung","t":"Bestätigung vor der Bestellung","i":"Hinweis: NOVALYXLABS-Produkte sind ausschließlich für die Laborforschung bestimmt.","w1":"Nur für Forschungszwecke","w2":"Diese Produkte sind nicht für den menschlichen oder tierischen Verzehr und nicht für medizinische, therapeutische oder diagnostische Zwecke bestimmt.","c1":"Ich bestätige, dass ich <strong>mindestens 18 Jahre alt</strong> bin.","c2":"Ich verstehe, dass diese Produkte <strong>ausschließlich für die Laborforschung</strong> bestimmt sind und <strong>unter keinen Umständen verzehrt</strong> oder für medizinische oder diagnostische Zwecke verwendet werden dürfen.","c3":"Ich bin für den Umgang mit den Produkten und die Einhaltung der für mich geltenden Vorschriften verantwortlich.","ok":"Bestätigen und fortfahren","no":"Abbrechen","f":"Ihre Bestätigung wird mit Zeitstempel zusammen mit Ihrer Bestellung gespeichert. Sie wird bei jedem neuen Besuch erneut abgefragt."},
  es:{"e":"Acceso restringido","et":"Solo para investigación de laboratorio","ei":"Lea y confirme los siguientes puntos para acceder al sitio.","eok":"Acceder al sitio","eno":"Salir","ce":"Confirmación","t":"Confirmación antes de pedir","i":"Recordatorio: los productos de NOVALYXLABS están reservados exclusivamente a la investigación de laboratorio.","w1":"Solo para uso en investigación","w2":"Estos productos no están destinados al consumo humano o animal, ni a un uso médico, terapéutico o diagnóstico.","c1":"Confirmo que tengo <strong>18 años o más</strong>.","c2":"Entiendo que estos productos están destinados <strong>exclusivamente a la investigación de laboratorio</strong> y que <strong>no deben consumirse en ningún caso</strong> por personas o animales, ni utilizarse con fines médicos o diagnósticos.","c3":"Soy responsable de su manipulación y del cumplimiento de la normativa que me sea aplicable.","ok":"Confirmar y continuar","no":"Cancelar","f":"Su confirmación queda fechada y registrada con su pedido. Se le volverá a pedir en cada nueva visita."},
  it:{"e":"Accesso riservato","et":"Solo per la ricerca di laboratorio","ei":"Leggi e conferma i seguenti punti per accedere al sito.","eok":"Accedi al sito","eno":"Esci","ce":"Conferma","t":"Conferma prima dell'ordine","i":"Promemoria: i prodotti NOVALYXLABS sono riservati esclusivamente alla ricerca di laboratorio.","w1":"Solo per uso di ricerca","w2":"Questi prodotti non sono destinati al consumo umano o animale, né a un uso medico, terapeutico o diagnostico.","c1":"Confermo di avere <strong>almeno 18 anni</strong>.","c2":"Comprendo che questi prodotti sono destinati <strong>esclusivamente alla ricerca di laboratorio</strong> e che <strong>non devono in alcun caso essere consumati</strong> da persone o animali, né usati a fini medici o diagnostici.","c3":"Sono responsabile della loro manipolazione e del rispetto delle norme che mi riguardano.","ok":"Conferma e continua","no":"Annulla","f":"La tua conferma viene datata e registrata con il tuo ordine. Ti verrà richiesta a ogni nuova visita."}
};
/* Une visite se termine après 30 min sans activité : le questionnaire est alors redemandé. */
var _NVX_GATE_VISIT=30*60*1000, _nvxGateEl=null, _nvxGateMem='', _nvxGateLast=0;
function _nvxGateLang(){
  try{ if(localStorage.getItem('nvx_lang')==='en') return 'en'; }catch(e){}
  var l='fr';
  try{ l=String((window.Shopify&&window.Shopify.locale)||document.documentElement.lang||'fr').slice(0,2).toLowerCase(); }catch(e){}
  return _NVX_GATE_T[l]?l:'fr';
}
function _nvxGateOk(){
  try{
    var ok=+localStorage.getItem('nvx_gate_ok')||0, a=+localStorage.getItem('nvx_gate_act')||0;
    if(ok&&a&&(Date.now()-a)<_NVX_GATE_VISIT) return true;
  }catch(e){}
  return !!_nvxGateMem;
}
/* Texte de la preuve envoyé avec la commande (Worker) et mis dans les attributs du panier. */
function _nvxGateProof(){
  try{ var p=localStorage.getItem('nvx_gate_proof'); if(p&&_nvxGateOk()) return p; }catch(e){}
  return _nvxGateMem;
}
function _nvxGateTouch(){
  if(Date.now()-_nvxGateLast<60000||!_nvxGateOk()) return;
  _nvxGateLast=Date.now();
  try{ localStorage.setItem('nvx_gate_act',String(_nvxGateLast)); }catch(e){}
}
function _nvxGateClose(){
  var ov=_nvxGateEl;
  if(ov&&ov.parentNode) ov.parentNode.removeChild(ov);
  document.documentElement.classList.add('nvx-gate-ok');
}
function _nvxGateOpen(entry){
  var ov=_nvxGateEl;
  if(!ov) return;
  var T=_NVX_GATE_T[_nvxGateLang()];
  ov._entry=!!entry;
  ov.classList.toggle('is-check',!entry);
  ov.querySelector('#nvxGateE').textContent=entry?T.e:T.ce;
  ov.querySelector('#nvxGateT').textContent=entry?T.et:T.t;
  ov.querySelector('#nvxGateI').textContent=entry?T.ei:T.i;
  ov.querySelector('#nvxGateW1').textContent=T.w1;
  ov.querySelector('#nvxGateW2').textContent=T.w2;
  ov.querySelector('#nvxGateC1').innerHTML=T.c1;
  ov.querySelector('#nvxGateC2').innerHTML=T.c2;
  ov.querySelector('#nvxGateC3').textContent=T.c3;
  ov.querySelector('#nvxGateF').textContent=T.f;
  var ok=ov.querySelector('#nvxGateOk');
  ok.textContent=entry?T.eok:T.ok; ok.disabled=true;
  ov.querySelector('#nvxGateNo').textContent=entry?T.eno:T.no;
  var cbs=ov.querySelectorAll('.nvxGateCb');
  for(var i=0;i<cbs.length;i++) cbs[i].checked=false;
  if(!ov.parentNode) document.body.insertBefore(ov,document.body.firstChild);
  document.documentElement.classList.remove('nvx-gate-ok');
  if(cbs[0]) cbs[0].focus({preventScroll:true});
}
function _nvxGateAccept(){
  var now=new Date(), when='';
  try{ when=now.toLocaleString('fr-FR',{timeZone:'Europe/Paris'})+' (Paris)'; }catch(e){ when=now.toISOString(); }
  var proof='18 ans ou plus + usage recherche uniquement + responsabilité : confirmé le '+when+' — langue '+_nvxGateLang().toUpperCase();
  _nvxGateMem=proof;
  try{
    localStorage.setItem('nvx_gate_ok',String(now.getTime()));
    localStorage.setItem('nvx_gate_act',String(now.getTime()));
    localStorage.setItem('nvx_gate_proof',proof);
  }catch(e){}
  try{ fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Attestation accès':proof}})}).catch(function(){}); }catch(e){}
}
function _nvxGateInit(){
  var ov=document.getElementById('nvxGateOv');
  if(!ov) return;
  _nvxGateEl=ov;
  var cbs=ov.querySelectorAll('.nvxGateCb'), ok=ov.querySelector('#nvxGateOk');
  function refresh(){ var all=true; for(var i=0;i<cbs.length;i++){ if(!cbs[i].checked) all=false; } ok.disabled=!all; }
  for(var i=0;i<cbs.length;i++) cbs[i].addEventListener('change',refresh);
  ov.querySelector('#nvxGateNo').addEventListener('click',function(){
    if(ov._entry){ window.location.href='https://www.google.fr'; } else { _nvxGateClose(); }
  });
  ov.addEventListener('click',function(e){ if(e.target===ov&&!ov._entry) _nvxGateClose(); });
  ok.addEventListener('click',function(){
    if(ok.disabled) return;
    var entry=ov._entry;
    _nvxGateAccept();
    _nvxGateClose();
    if(!entry) checkout();
  });
  if(_nvxGateOk()) _nvxGateClose(); else _nvxGateOpen(true);
  ['click','scroll','keydown','touchstart'].forEach(function(ev){ window.addEventListener(ev,_nvxGateTouch,{passive:true}); });
  /* Retour sur l'onglet après plus de 30 min : nouvelle visite, on redemande. */
  document.addEventListener('visibilitychange',function(){
    if(!document.hidden&&!_nvxGateOk()&&!ov.parentNode) _nvxGateOpen(true);
  });
}
(function(){
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',_nvxGateInit); else _nvxGateInit();
})();
async function checkout(){var c=await fetchCart();if(!c||!c.item_count){toast('Panier vide');return;}if(!_nvxGateOk()){_nvxGateOpen();return;}try{var val=(c.total_price||0)/100;if(typeof fbq==='function')fbq('track','InitiateCheckout',{value:val,currency:'EUR'});if(typeof gtag==='function')gtag('event','begin_checkout',{currency:'EUR',value:val});}catch(e){}if(typeof openIncPayChoice==='function'){openIncPayChoice();return;}window.location.href='/checkout';}
async function openCart(){var _tt=document.getElementById('_toast');if(_tt)_tt.style.display='none';var ov=document.getElementById('cartOv'),d=document.getElementById('cartD');if(!ov||!d){window.location.href='/cart';return;}_lockScroll();ov.classList.add('open');d.classList.add('open');var c=await fetchCart();if(c)renderCart(c);}
function closeCart(){var ov=document.getElementById('cartOv'),d=document.getElementById('cartD');if(ov)ov.classList.remove('open');if(d)d.classList.remove('open');_unlockScroll();}

/* ── SEARCH ── */
var _st=null;
function _goToProduct(handle){
  var el=document.getElementById('srEl');if(el){el.classList.remove('open');el.innerHTML='';}
  var inp=document.getElementById('srchInp');if(inp)inp.value='';
  var card=document.querySelector('.pc[data-handle="'+handle+'"], .kit-card[data-handle="'+handle+'"]');
  if(!card){toast('Produit non trouvé sur la page');return;}
  var h=document.getElementById('hdr');
  window.scrollTo({top:card.getBoundingClientRect().top+window.scrollY-(h?h.offsetHeight:104)-16,behavior:'smooth'});
  card.style.transition='box-shadow .25s,border-color .25s';
  card.style.boxShadow='0 0 0 2px var(--n1),0 0 34px rgba(0,212,255,.35)';
  card.style.borderColor='var(--n1)';
  setTimeout(function(){card.style.boxShadow='';card.style.borderColor='';},2200);
}
async function handleSearch(val){
  var el=document.getElementById('srEl');if(!el)return;
  if(!val.trim()){el.innerHTML='';return;}
  clearTimeout(_st);
  _st=setTimeout(async function(){
    el.innerHTML='<div class="sr-it" style="color:var(--m3);font-size:11px">Recherche...</div>';
    var d=await ajaxCart('GET','/search/suggest.json?q='+encodeURIComponent(val)+'&resources[type]=product&resources[limit]=6');
    var results=d&&d.resources&&d.resources.results&&d.resources.results.products||[];
    if(!results.length){el.innerHTML='<div class="sr-it" style="color:var(--m3);font-size:11px">Aucun résultat</div>';return;}
    el.innerHTML=results.map(function(p){
      var price=parseFloat(p.price).toFixed(2).replace('.',',');
      var img=p.featured_image&&p.featured_image.url||'';
      return '<div class="sr-it" onclick="_goToProduct(\''+p.handle+'\')">'+(img?'<div class="sr-th"><img src="'+img+'" style="width:34px;height:34px;object-fit:cover;border-radius:4px"></div>':'')+'<div><div class="sr-n">'+p.title+'</div><div class="sr-p">'+price+' €</div></div></div>';
    }).join('');
  },300);
}

/* ── PARTICLES ── */
var _cv=document.getElementById('pc'),_ctx=_cv&&_cv.getContext('2d'),_W,_H,_pts=[];
function _rsz(){if(!_cv)return;_W=_cv.width=window.innerWidth;_H=_cv.height=window.innerHeight;}
_rsz();window.addEventListener('resize',_rsz);
function Pt(){this.reset();}
Pt.prototype.reset=function(){this.x=Math.random()*_W;this.y=Math.random()*_H;this.r=Math.random()*1.3+.25;this.vx=(Math.random()-.5)*.2;this.vy=(Math.random()-.5)*.2;this.a=Math.random()*.38+.08;this.c=Math.random()>.5?'#00B7FF':'#00D4FF';};
Pt.prototype.update=function(){this.x+=this.vx;this.y+=this.vy;if(this.x<0||this.x>_W||this.y<0||this.y>_H)this.reset();};
Pt.prototype.draw=function(){if(!_ctx)return;_ctx.save();_ctx.globalAlpha=this.a;_ctx.fillStyle=this.c;_ctx.beginPath();_ctx.arc(this.x,this.y,this.r,0,Math.PI*2);_ctx.fill();_ctx.restore();};
if(_ctx){for(var _i=0;_i<60;_i++)_pts.push(new Pt());}
function _conn(){if(!_ctx)return;for(var i=0;i<_pts.length;i++)for(var j=i+1;j<_pts.length;j++){var dx=_pts[i].x-_pts[j].x,dy=_pts[i].y-_pts[j].y,d=Math.sqrt(dx*dx+dy*dy);if(d<95){_ctx.save();_ctx.globalAlpha=(1-d/95)*.048;_ctx.strokeStyle='#00B7FF';_ctx.lineWidth=.5;_ctx.beginPath();_ctx.moveTo(_pts[i].x,_pts[i].y);_ctx.lineTo(_pts[j].x,_pts[j].y);_ctx.stroke();_ctx.restore();}}}
function _anim(){if(!_ctx)return;_ctx.clearRect(0,0,_W,_H);_pts.forEach(function(p){p.update();p.draw();});_conn();requestAnimationFrame(_anim);}
_anim();

/* ── REVEAL ── */
var _ro=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)e.target.classList.add('visible');});},{threshold:.1});
document.querySelectorAll('.reveal').forEach(function(el){_ro.observe(el);});
var _mo=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting)e.target.querySelectorAll('.m-fill').forEach(function(b){var w=getComputedStyle(b).getPropertyValue('--w');b.style.width='0';setTimeout(function(){b.style.width=w||'0%';},80);});});},{threshold:.3});
document.querySelectorAll('.qual-sec').forEach(function(el){_mo.observe(el);});

/* ── UI ── */
function openAC(){_lockScroll();document.getElementById('acOv')&&document.getElementById('acOv').classList.add('open');document.getElementById('acD')&&document.getElementById('acD').classList.add('open');}
function closeAC(){document.getElementById('acOv')&&document.getElementById('acOv').classList.remove('open');document.getElementById('acD')&&document.getElementById('acD').classList.remove('open');_unlockScroll();}
function swAC(el,tab){document.querySelectorAll('.ac-tab').forEach(function(t){t.classList.remove('active');});el.classList.add('active');document.querySelectorAll('.ac-sec').forEach(function(s){s.classList.remove('active');});document.getElementById('ac-'+tab)&&document.getElementById('ac-'+tab).classList.add('active');}
var _wl=[];
function openWL(){_lockScroll();document.getElementById('wlOv')&&document.getElementById('wlOv').classList.add('open');document.getElementById('wlD')&&document.getElementById('wlD').classList.add('open');}
function closeWL(){document.getElementById('wlOv')&&document.getElementById('wlOv').classList.remove('open');document.getElementById('wlD')&&document.getElementById('wlD').classList.remove('open');_unlockScroll();}
function toggleWL(btn,name,price,id){var idx=_wl.findIndex(function(i){return i.id===id;});if(idx>-1){_wl.splice(idx,1);btn.classList.remove('act');toast('Retiré de la wishlist');}else{_wl.push({name:name,price:price,id:id});btn.classList.add('act');toast('♥ '+name+' sauvegardé');}var b=document.getElementById('wlBdg');if(b){b.textContent=_wl.length;b.style.display=_wl.length?'flex':'none';}renderWL();}
function renderWL(){var bd=document.getElementById('wlBody');if(!bd)return;if(!_wl.length){bd.innerHTML='<div class="cart-empty"><p style="font-size:11px;color:var(--m2)">Aucun article sauvegardé</p></div>';return;}bd.innerHTML=_wl.map(function(it){return '<div class="wl-it"><div style="flex:1"><div class="wl-n">'+it.name+'</div><div class="wl-p">'+it.price.toFixed(2).replace('.',',')+' €</div></div><button class="wl-add" onclick="addCart(\''+it.name+'\','+it.price+',\''+it.id+'\',this)">+ Panier</button></div>';}).join('');}
var _cmp=[];
function addCmp(name,id){if(_cmp.find(function(i){return i.id===id;})){toast('Déjà dans le comparateur');return;}if(_cmp.length>=3){toast('Max 3 produits');return;}_cmp.push({name:name,id:id});updCmp();toast(name+' ajouté');}
function updCmp(){var bar=document.getElementById('cmpBar');if(!bar)return;_cmp.length>0?bar.classList.add('show'):bar.classList.remove('show');var cnt=document.getElementById('cmpCnt');if(cnt)cnt.textContent=_cmp.length;for(var i=0;i<3;i++){var sl=document.getElementById('cs'+i);if(!sl)continue;if(_cmp[i]){sl.classList.add('filled');sl.innerHTML=_cmp[i].name;}else{sl.classList.remove('filled');sl.innerHTML='Slot '+(i+1);}}}
function clearCmp(){_cmp=[];updCmp();}
function toggleCmp(){if(_cmp.length)runCmp();else toast('Cliquez sur ⚖ sur les fiches produits');}
function runCmp(){if(_cmp.length<2){toast('Ajoutez au moins 2 produits');return;}alert('Comparaison :\n'+_cmp.map(function(i){return i.name;}).join('\n'));}
function filterP(cat,btn){document.querySelectorAll('.fl-tags .f-tag').forEach(function(t){t.classList.remove('active');});btn.classList.add('active');document.querySelectorAll('#prodsGrid .pc').forEach(function(c){if(cat==='tous'){c.style.display='flex';return;}var cats=(c.dataset.cat||'').split(' ');c.style.display=cats.includes(cat)?'flex':'none';});}
function sortP(v){var g=document.getElementById('prodsGrid');if(!g)return;var cs=Array.from(g.querySelectorAll('.pc'));cs.sort(function(a,b){if(v==='pa')return parseFloat(a.dataset.price||0)-parseFloat(b.dataset.price||0);if(v==='pd')return parseFloat(b.dataset.price||0)-parseFloat(a.dataset.price||0);if(v==='pu')return parseFloat(b.dataset.purity||0)-parseFloat(a.dataset.purity||0);return 0;});cs.forEach(function(c){g.appendChild(c);});}
function tFaq(el){var a=el.nextElementSibling,ic=el.querySelector('.faq-ic'),open=a.classList.contains('open');document.querySelectorAll('.faq-a').forEach(function(x){x.classList.remove('open');});document.querySelectorAll('.faq-ic').forEach(function(x){x.classList.remove('open');});if(!open){a.classList.add('open');ic.classList.add('open');}}
document.addEventListener('DOMContentLoaded',function(){

  var _cItem=document.getElementById('nvxContactItem');
  var _cBtn=document.getElementById('nvxContactBtn');
  if(_cItem && _cBtn){
    _cBtn.addEventListener('click',function(e){
      e.stopPropagation();
      var isOpen=_cItem.classList.toggle('open');
      _cBtn.setAttribute('aria-expanded',isOpen?'true':'false');
    });
    document.addEventListener('click',function(e){
      if(!_cItem.contains(e.target)){_cItem.classList.remove('open');_cBtn.setAttribute('aria-expanded','false');}
    });
    document.addEventListener('keydown',function(e){
      if(e.key==='Escape'){_cItem.classList.remove('open');_cBtn.setAttribute('aria-expanded','false');}
    });
  }
});
function toast(msg){var t=document.getElementById('_toast');if(!t){t=document.createElement('div');t.id='_toast';t.style.cssText='position:fixed;bottom:86px;left:50%;transform:translateX(-50%);background:rgba(255,255,255,.98);border:1px solid rgba(0,212,255,.32);color:var(--tx);font-size:11px;font-weight:500;padding:9px 18px;border-radius:5px;z-index:9999;backdrop-filter:blur(14px);white-space:nowrap;box-shadow:0 4px 18px rgba(20,25,45,.14);transition:opacity .3s';document.body.appendChild(t);}t.textContent=msg;t.style.opacity='1';clearTimeout(t._t);t._t=setTimeout(function(){t.style.opacity='0';},2800);}
function toastCart(msg){
  var t=document.getElementById('_toast');
  if(!t){
    t=document.createElement('div');
    t.id='_toast';
    document.body.appendChild(t);
  }
  t.style.cssText='position:fixed;bottom:86px;left:50%;transform:translateX(-50%);background:rgba(255,255,255,.98);border:1px solid rgba(0,212,255,.32);color:var(--tx);font-size:11px;font-weight:500;padding:9px 10px 9px 16px;border-radius:5px;z-index:9999;backdrop-filter:blur(14px);white-space:nowrap;box-shadow:0 4px 18px rgba(20,25,45,.14);transition:opacity .3s;display:flex;align-items:center;gap:10px';
  t.innerHTML='<span>'+msg+'</span><button onclick="openCart()" style="background:transparent;border:1px solid rgba(0,212,255,.5);color:#0095FF;font-size:10px;font-weight:700;padding:5px 11px;border-radius:4px;cursor:pointer;white-space:nowrap">Voir le panier →</button>';
  t.style.opacity='1';
  clearTimeout(t._t);
  t._t=setTimeout(function(){t.style.opacity='0';},3800);
}

/* ── COA ── */
/* All 14 real peptides now have a real lab-issued certificate (see _coaFiles above) and no longer read from here.
   Melanotan I (mt1) has no real certificate yet and no longer links to a generated report either (its product page
   and homepage card now show a plain "bientôt disponible" label) — so this DB is intentionally empty. The
   generator function below (openCOA's fallback branch) stays in place, unused, ready to serve again if a
   product's real certificate ever needs a temporary placeholder in the future. */
var _coaDB={};
function _chromo(p,col,rt){
  var W2=600,H2=168,padL=34,padR=20,padT=16,padB=30;
  var plotW=W2-padL-padR,plotH=H2-padT-padB,base=H2-padB;
  var max=Math.max.apply(null,p),step=plotW/(p.length-1);
  var pts=p.map(function(v,i){return [padL+i*step, base-(v/max)*plotH*0.92];});
  var peakIdx=p.indexOf(max);
  var peak=pts[peakIdx];
  // smooth path via quadratic mid-point interpolation
  var d='M'+pts[0][0]+','+pts[0][1];
  for(var i=1;i<pts.length;i++){
    var mx=(pts[i-1][0]+pts[i][0])/2, my=(pts[i-1][1]+pts[i][1])/2;
    d+=' Q'+pts[i-1][0]+','+pts[i-1][1]+' '+mx+','+my;
  }
  d+=' T'+pts[pts.length-1][0]+','+pts[pts.length-1][1];
  var area=d+' L'+pts[pts.length-1][0]+','+base+' L'+pts[0][0]+','+base+' Z';
  var grid='';
  for(var g=1;g<=3;g++){
    var gy=padT+(plotH*g/4);
    grid+='<line x1="'+padL+'" y1="'+gy+'" x2="'+(W2-padR)+'" y2="'+gy+'" stroke="rgba(18,21,31,.08)" stroke-width="1" stroke-dasharray="2,4"/>';
  }
  var ticks='';
  for(var t=0;t<p.length;t+=Math.ceil(p.length/6)){
    var tx=padL+t*step;
    ticks+='<line x1="'+tx+'" y1="'+base+'" x2="'+tx+'" y2="'+(base+4)+'" stroke="rgba(18,21,31,.20)" stroke-width="1"/>';
  }
  var peakLabel='';
  if(rt){
    var lx=Math.min(Math.max(peak[0],padL+38),W2-padR-38);
    peakLabel='<line x1="'+peak[0]+'" y1="'+peak[1]+'" x2="'+peak[0]+'" y2="'+base+'" stroke="'+col+'" stroke-opacity=".35" stroke-width="1" stroke-dasharray="2,3"/>'+
      '<circle cx="'+peak[0]+'" cy="'+peak[1]+'" r="4.5" fill="'+col+'" opacity=".18"/>'+
      '<circle cx="'+peak[0]+'" cy="'+peak[1]+'" r="2.4" fill="'+col+'"/>'+
      '<rect x="'+(lx-30)+'" y="'+(peak[1]-24)+'" width="60" height="16" rx="3" fill="#FFFFFF" fill-opacity=".95" stroke="'+col+'" stroke-opacity=".3" stroke-width=".6"/>'+
      '<text x="'+lx+'" y="'+(peak[1]-13)+'" text-anchor="middle" font-family="Arial" font-size="8.5" font-weight="700" fill="'+col+'">'+rt+'</text>';
  }
  return '<svg viewBox="0 0 '+W2+' '+H2+'" fill="none">'+
    '<defs><linearGradient id="cg" x1="0" y1="0" x2="0" y2="1"><stop offset="0%" stop-color="'+col+'" stop-opacity=".28"/><stop offset="100%" stop-color="'+col+'" stop-opacity="0"/></linearGradient>'+
    '<linearGradient id="cl" x1="0" y1="0" x2="1" y2="0"><stop offset="0%" stop-color="#0095FF"/><stop offset="100%" stop-color="'+col+'"/></linearGradient></defs>'+
    grid+
    '<line x1="'+padL+'" y1="'+base+'" x2="'+(W2-padR)+'" y2="'+base+'" stroke="rgba(18,21,31,.16)" stroke-width="1"/>'+
    ticks+
    '<path d="'+area+'" fill="url(#cg)"/>'+
    '<path d="'+d+'" stroke="url(#cl)" stroke-width="2" fill="none" stroke-linejoin="round" stroke-linecap="round"/>'+
    peakLabel+
    '<text x="'+padL+'" y="'+(H2-8)+'" font-family="Arial" font-size="8" fill="rgba(18,21,31,.42)">0 min</text>'+
    '<text x="'+(W2-padR)+'" y="'+(H2-8)+'" text-anchor="end" font-family="Arial" font-size="8" fill="rgba(18,21,31,.42)">Temps de rétention</text>'+
    '</svg>';
}
/* Real lab-issued certificates (Brown Biology Institute) — takes priority over the generated report below. Melanotan I (mt1) still falls back to the generated version until its certificate is supplied.
   URLs come from window._coaAssetUrls, rendered by theme.liquid via the `asset_url` filter so the PDFs are served from the shop's own domain (novalyxlabs.fr), never cdn.shopify.com. If that map is missing for any reason, fall back to an empty object rather than ever exposing a Shopify-hosted link — unmapped ids just drop through to the generated report below. */
var _coaFiles=(typeof window!=='undefined'&&window._coaAssetUrls)?window._coaAssetUrls:{};
/* COA sur demande : le bouton ouvre WhatsApp avec un message pré-rempli au nom du produit, au lieu d'afficher le certificat. */
var NVX_COA_NAMES={ghkcu50:'GHK-Cu 50 mg',ghkcu100:'GHK-Cu 100 mg',klow:'Klow Blend 80 mg',cjcipa10:'CJC 1295 + Ipamorelin 10 mg',ahkcu:'AHK-Cu 50 mg',ghrp6:'GHRP-6 Acetate 5 mg',nad500:'NAD+ 500 mg',sel:'Selank 10 mg',tes5:'Tesamorelin 5 mg',semax:'Semax 10 mg',motsc:'MOTS-C 10 mg',motsc20:'MOTS-C 20 mg',cagri5:'Cagrilintide 5 mg',tbbpc10:'TB-500 + BPC-157 10 mg',kpv10:'KPV 10 mg',amino10:'5-Amino-1MQ 10 mg',mt1:'Melanotan I 10 mg',s5:'5 mg',s10:'10 mg',s20:'20 mg',s30:'30 mg',pk5:'Pack 5 mg',pk10:'Pack 10 mg',pk20:'Pack 20 mg',pk30:'Pack 30 mg'};
function openCOA(id){
  var f=_coaFiles[id];
  if(f){window.open(f,'_blank','noopener');return;}
  var name=NVX_COA_NAMES[id];
  var msg=name?'Bonjour, je souhaiterais recevoir le COA du '+name+'.':'Bonjour, je souhaiterais recevoir un COA.';
  window.open('https://wa.me/33743787643?text='+encodeURIComponent(msg),'_blank');
}
function closeCOA(){document.getElementById('modalOv')&&document.getElementById('modalOv').classList.remove('open');_unlockScroll();}

/* ── REVIEWS ── */
function _stars(n){var s='';for(var i=1;i<=5;i++){s+=i<=Math.round(n)?'★':'<span style="opacity:.18">★</span>';}return s;}
function openReviews(handle){
  var d=(window.NVX_REVIEWS||{})[handle];if(!d)return;
  _lockScroll();
  var revs=d.reviews||[];
  var sum=0;revs.forEach(function(r){sum+=r.rating;});
  var avg=revs.length?Math.round((sum/revs.length)*10)/10:0;
  document.getElementById('reviewsHeader').innerHTML='<div class="rev-hdr"><div><div class="rev-big">'+avg+'</div><div class="rev-big-stars">'+_stars(avg)+'</div><div class="rev-big-cnt">'+revs.length+' avis vérifiés</div></div><div class="rev-name">'+d.name+'</div></div>';
  var list=document.getElementById('reviewsList');
  if(revs.length){
    list.innerHTML=revs.slice().reverse().map(function(r){
      var dt=new Date(r.date);var dtxt=isNaN(dt)?r.date:dt.toLocaleDateString('fr-FR',{day:'numeric',month:'short',year:'numeric'});
      return '<div class="rev-item"><div class="rev-item-top"><span class="rev-author">'+r.author+'</span><span class="rev-date">'+dtxt+'</span></div><div class="rev-stars-sm">'+_stars(r.rating)+'</div><div class="rev-text">'+r.text+'</div></div>';
    }).join('');
  } else {
    list.innerHTML='<div style="font-size:12px;color:var(--m3)">Aucun avis pour le moment. Soyez le premier à en laisser un.</div>';
  }
  var pf=document.getElementById('revProductField');if(pf)pf.value=d.name;
  document.getElementById('coaBody').style.display='none';
  document.getElementById('reviewsBody').style.display='block';
  document.getElementById('modalOv').classList.add('open');
}
function openAllReviews(){
  _lockScroll();
  var all=window.NVX_REVIEWS||{};
  var flat=[];
  Object.keys(all).forEach(function(h){
    var d=all[h];(d.reviews||[]).forEach(function(r){flat.push({author:r.author,rating:r.rating,date:r.date,text:r.text,product:d.name});});
  });
  flat.sort(function(a,b){return new Date(b.date)-new Date(a.date);});
  var sum=0;flat.forEach(function(r){sum+=r.rating;});
  var avg=flat.length?Math.round((sum/flat.length)*10)/10:0;
  var _i18n=window.NVX_I18N||{revCountSuffix:' avis vérifiés',verifiedBadge:'✓ Vérifié'};
  document.getElementById('reviewsHeader').innerHTML='<div class="rev-hdr"><div><div class="rev-big">'+avg+'</div><div class="rev-big-stars">'+_stars(avg)+'</div><div class="rev-big-cnt">'+flat.length+_i18n.revCountSuffix+'</div></div><div class="rev-name">Tous les avis NOVALYXLABS</div></div>';
  var list=document.getElementById('reviewsList');
  list.innerHTML=flat.length?flat.map(function(r){
    var dt=new Date(r.date);var dtxt=isNaN(dt)?r.date:dt.toLocaleDateString('fr-FR',{day:'numeric',month:'short',year:'numeric'});
    return '<div class="rev-item"><div class="rev-item-top"><span class="rev-author">'+r.author+' <span style="display:inline-flex;align-items:center;gap:3px;font-size:9px;font-weight:700;color:#0F9D68;background:rgba(15,157,104,.1);padding:2px 7px;border-radius:20px;vertical-align:middle">'+_i18n.verifiedBadge+'</span></span><span class="rev-date">'+dtxt+'</span></div><div class="rev-stars-sm">'+_stars(r.rating)+'</div><div style="font-size:10px;color:var(--m3);margin-bottom:4px">'+r.product+'</div><div class="rev-text">'+r.text+'</div></div>';
  }).join(''):'<div style="font-size:12px;color:var(--m3)">Aucun avis pour le moment.</div>';
  var pf2=document.getElementById('revProductField');if(pf2)pf2.value='Avis général';
  document.getElementById('coaBody').style.display='none';
  document.getElementById('reviewsBody').style.display='block';
  document.getElementById('modalOv').classList.add('open');
}
(function(){
  var pick=document.getElementById('revStarPick');
  if(!pick)return;
  var rf=document.getElementById('revRatingField');
  function paint(v){Array.prototype.forEach.call(pick.children,function(s){s.classList.toggle('on',+s.dataset.v<=v);});}
  paint(5);
  Array.prototype.forEach.call(pick.children,function(s){
    s.addEventListener('click',function(){var v=+s.dataset.v;if(rf)rf.value=v;paint(v);});
  });
})();

/* ── SCROLL ── */
document.querySelectorAll('a[href^="#"]').forEach(function(a){a.addEventListener('click',function(e){var t=document.querySelector(a.getAttribute('href'));if(t){e.preventDefault();var h=document.getElementById('hdr');window.scrollTo({top:t.getBoundingClientRect().top+window.scrollY-(h?h.offsetHeight:104)-8,behavior:'smooth'});}});});
window.addEventListener('scroll',function(){var hdr=document.getElementById('hdr');if(hdr)hdr.style.boxShadow=window.scrollY>50?'0 4px 28px rgba(20,25,45,.16)':'none';});

/* ── EMAIL ALERT MODAL ── */
var _alertModal=null;
function showAlertModal(productName){
  _lockScroll();
  if(!_alertModal){
    _alertModal=document.createElement('div');
    _alertModal.style.cssText='position:fixed;inset:0;background:rgba(0,0,0,.85);backdrop-filter:blur(12px);z-index:9998;display:flex;align-items:center;justify-content:center;padding:16px';
    _alertModal.innerHTML='<div style="background:#FFFFFF;border:1px solid rgba(0,212,255,.3);border-radius:12px;padding:28px;max-width:420px;width:100%;box-shadow:0 20px 60px rgba(20,25,45,.16)"><div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:16px"><div style="font-family:Orbitron,sans-serif;font-size:13px;font-weight:700;color:#0095FF;letter-spacing:.1em">ALERTE DISPONIBILITÉ</div><button onclick="closeAlertModal()" style="background:none;border:none;color:#5B6472;cursor:pointer;font-size:22px;line-height:1">×</button></div><div id="_alertTitle" style="font-size:14px;font-weight:600;color:var(--tx);margin-bottom:6px"></div><div style="font-size:11px;color:#5B6472;margin-bottom:18px">Saisissez votre e-mail pour être notifié dès que ce produit sera disponible.</div><input id="_alertEmail" type="email" placeholder="votre@email.com" style="width:100%;background:#F7FAFD;border:1px solid rgba(0,212,255,.25);border-radius:7px;padding:11px 14px;color:var(--tx);font-size:13px;outline:none;box-sizing:border-box;margin-bottom:12px"><button onclick="submitAlert()" style="width:100%;background:linear-gradient(135deg,#00B7FF,#00D4FF);border:none;border-radius:7px;padding:12px;color:#000;font-size:12px;font-weight:700;cursor:pointer;letter-spacing:.05em">🔔 M\'ALERTER</button><div id="_alertMsg" style="margin-top:10px;font-size:11px;text-align:center;color:#0095FF;display:none"></div></div>';
    _alertModal.addEventListener('click',function(e){if(e.target===_alertModal)closeAlertModal();});
    document.body.appendChild(_alertModal);
  }
  _alertModal._product=productName;
  document.getElementById('_alertTitle').textContent=productName;
  document.getElementById('_alertEmail').value='';
  document.getElementById('_alertMsg').style.display='none';
  _alertModal.style.display='flex';
  setTimeout(function(){document.getElementById('_alertEmail').focus();},100);
}
function closeAlertModal(){if(_alertModal)_alertModal.style.display='none';_unlockScroll();}
function submitAlert(){
  var email=document.getElementById('_alertEmail').value.trim();
  var msg=document.getElementById('_alertMsg');
  if(!email||!email.includes('@')){msg.style.display='block';msg.style.color='#D63B3B';msg.textContent='Veuillez saisir une adresse e-mail valide.';return;}
  var alerts=JSON.parse(localStorage.getItem('nvx_alerts')||'[]');
  alerts.push({product:_alertModal._product,email:email,date:new Date().toISOString()});
  localStorage.setItem('nvx_alerts',JSON.stringify(alerts));
  msg.style.display='block';msg.style.color='#0095FF';msg.textContent='✓ Alerte enregistrée ! Vous serez notifié à '+email;
  setTimeout(function(){closeAlertModal();},2500);
}

/* ── CSS INJECTION (un seul bloc) ── */
(function(){
  var s=document.createElement('style');
  s.textContent=
    /* Global */
    '[id]{scroll-margin-top:110px}'+
    /* Kit image override — higher specificity than .kit-ic svg */
    /* Kit CSS injected via JS after DOM — wins over static theme CSS */
    /* Mobile */
    '@media(max-width:768px){'+
      '[id]{scroll-margin-top:130px}'+
      '.hdr-util{height:32px!important;gap:6px!important;padding:0 6px!important;flex-wrap:nowrap!important;justify-content:center!important;overflow-x:auto!important;overflow-y:hidden!important;scrollbar-width:none!important;overscroll-behavior:contain!important;overscroll-behavior-x:contain!important;-webkit-overflow-scrolling:touch!important;touch-action:pan-x!important}'+
      '.hdr-util::-webkit-scrollbar{display:none}'+
      '.hdr-util-item{font-size:11px!important;white-space:nowrap!important;gap:5px!important;flex-shrink:0!important}'+
      '.hdr-util-item svg{width:13px!important;height:13px!important;flex-shrink:0!important}'+
      '.hdr-util-text{white-space:nowrap!important}'+
      '.hdr-util-sep{flex-shrink:0!important}'+
      '.hdr-util-sep{flex-shrink:0}'+
      'header#hdr{position:fixed;top:'+(document.body.classList.contains('has-promo')?38:0)+'px;left:0;right:0;z-index:700}'+
      '.hdr-top{padding:0 10px!important;height:54px!important;display:flex;align-items:center;justify-content:space-between;gap:6px}'+
      '.hdr-acts .btn-ghost{display:none!important}'+
      '.nvx-contact-item{display:none!important}'+
      '.hdr-search{flex:1!important;max-width:none!important;min-width:0!important;margin:0 4px!important}'+
      '.hdr-search input{font-size:11px!important;padding:7px 8px 7px 28px!important;width:100%!important}'+
      '.s-ic{width:14px!important;height:14px!important;left:8px!important}'+
      '.logo-t{font-size:10px!important;letter-spacing:.06em!important}'+
      '.logo-w{gap:6px!important}'+
      '.logo-w svg{width:22px!important;height:22px!important}'+
      '.hdr-acts{gap:1px!important}'+
      '.hdr-acts button,.hdr-acts a{width:30px!important;height:30px!important;min-width:30px!important;padding:0!important}'+
      '.hdr-acts svg{width:15px!important;height:15px!important}'+
      '.bdg{min-width:13px!important;width:13px!important;height:13px!important;font-size:8px!important;top:-2px!important;right:-2px!important}'+
      '.hdr-nav{padding:0 10px!important;height:32px!important;overflow-x:auto!important;overflow-y:hidden!important;scrollbar-width:none!important;overscroll-behavior:contain!important;overscroll-behavior-x:contain!important;-webkit-overflow-scrolling:touch!important;touch-action:pan-x!important}'+
      '.hdr-nav::-webkit-scrollbar{display:none}'+
      '.hdr-nav a{font-size:9px!important;padding:0 10px!important;height:32px!important;white-space:nowrap!important}'+
      'body{padding-top:'+(document.getElementById('hdr')?(document.body.classList.contains('has-promo')?156:118):0)+'px!important}'+
      /* Drawer */
      '.drawer,.cart-d,.ac-d,.wl-d{width:100vw!important;max-width:100vw!important}'+
      '.cart-body{padding:10px 12px!important;gap:8px!important}'+
      '.cart-it{grid-template-columns:44px 1fr auto!important;gap:7px!important;padding:8px!important}'+
      '.ci-th{width:44px!important;height:44px!important}'+
      '.ci-th img{width:44px!important;height:44px!important}'+
      '.ci-n{font-size:11px!important}'+
      '.ci-price{font-size:12px!important}'+
      '.q-btn{width:24px!important;height:24px!important}'+
      '.cart-foot{padding:10px 12px!important;gap:7px!important}'+
      '.promo-row{gap:6px!important}'+
      '.promo-btn{padding:8px 12px!important;font-size:11px!important;white-space:nowrap!important}'+
      '.ct-row{font-size:11px!important}'+
      '.ct-row.total{font-size:13px!important}'+
      '.cart-co{padding:11px!important;font-size:11px!important}'+
      '.pnl-hdr{padding:12px 14px!important}'+
      /* Filter */
      '.filter-bar{padding:6px 10px!important;flex-wrap:nowrap!important;overflow-x:auto!important;scrollbar-width:none!important;top:'+(document.body.classList.contains('has-promo')?156:118)+'px!important}'+
      '.filter-bar::-webkit-scrollbar{display:none}'+
      '.fl-lbl{display:none!important}'+
      '.fl-tags{flex-wrap:nowrap!important;gap:5px!important;flex:none!important}'+
      '.f-tag{font-size:9px!important;padding:4px 9px!important;border-radius:14px!important;white-space:nowrap!important;flex-shrink:0!important}'+
      '.fl-right{flex-shrink:0!important;gap:5px!important;margin-left:auto!important}'+
      '.cmp-btn{font-size:9px!important;padding:4px 8px!important;white-space:nowrap!important}'+
      '.sort-sel{font-size:9px!important;padding:4px 6px!important;max-width:90px!important}'+
      /* Products */
      '.prods-grid{grid-template-columns:1fr!important}'+
      '.prods-grid:not(.show-all) .pc:nth-child(n+9){display:none!important}'+
      '.prods-loadmore{display:flex!important}'+
      '.prods-grid.show-all+.prods-loadmore{display:none!important}'+
      '.pc{flex-direction:row!important;align-items:stretch!important;gap:0!important;padding:0!important;overflow:hidden}'+
      '.p-img{width:118px!important;min-width:118px!important;height:auto!important;min-height:150px!important;border-radius:0!important;flex-shrink:0;position:relative!important}'+
      /* Badge pureté: haut droite */
      '.p-img .p-bdg{position:absolute!important;top:3px!important;right:3px!important;left:auto!important;font-size:6.5px!important;padding:2px 4px!important;z-index:2!important}'+
      /* Etiquette: bas gauche */
      '.p-img .p-tag{position:absolute!important;bottom:3px!important;left:3px!important;top:auto!important;right:auto!important;font-size:6.5px!important;padding:2px 5px!important;z-index:2!important}'+
      '.p-img .p-tag.stk{bottom:19px!important}'+
      '.p-info{flex:1!important;padding:7px!important;min-width:0;display:flex;flex-direction:column;gap:1px}'+
      '.p-ref{font-size:7px!important;margin-bottom:0!important}'+
      '.p-name{font-size:11px!important;line-height:1.15!important;margin-bottom:0!important}'+
      '.p-sub{font-size:8.5px!important;margin-bottom:0!important}'+
      '.pc-rating{margin-bottom:0!important}'+
      '.p-pur{font-size:7.5px!important;margin-bottom:0!important}'+
      '.stk-bar{margin-bottom:0!important}'+
      '.stk-row{margin-bottom:0!important;gap:5px!important}'+
      '.stk-t{font-size:7.5px!important}'+
      '.p-foot{flex-direction:row!important;align-items:center!important;justify-content:space-between!important;gap:6px!important;margin-top:4px!important}'+
      '.p-price{font-size:13px!important}'+
      '.btn-add{padding:6px 10px!important;font-size:9.5px!important}'+
      '.btn-coa-s{font-size:8.5px!important;padding:4px 7px!important}'+
      '.p-info>div[style*="margin-top:7px"]{margin-top:3px!important}'+
      /* Sections */
      '.sec-sep{padding:40px 14px!important}'+
      '.s-title{font-size:22px!important}'+
      '.ship-sec{padding:16px 14px!important}'+
      '.ship-in{grid-template-columns:1fr!important;gap:20px!important}'+
      '.kits-grid{grid-template-columns:1fr!important}'+
      /* COA mobile */
      '.modal-ov{padding:0!important;align-items:flex-end!important}'+
      '.modal{max-width:100vw!important;width:100vw!important;max-height:90dvh!important;border-radius:20px 20px 0 0!important;margin:0!important;overflow-y:auto!important;-webkit-overflow-scrolling:touch!important;position:relative!important}'+
      /* Sticky to the modal's own scroll area (like on desktop) instead of fixed to the screen, so it can never end up hidden behind the browser chrome or off-screen, whatever the modal's height or the toolbar state. */
      '.m-cls{position:sticky!important;top:10px!important;right:10px!important;float:right!important;margin-right:10px!important;width:28px!important;height:28px!important;font-size:12px!important;z-index:999!important;background:rgba(18,21,31,.10)!important;border:1px solid rgba(18,21,31,.14)!important;opacity:.75!important}'+
      '.coa-doc{padding:16px!important}'+
      '.coa-hdr{flex-direction:column!important;gap:8px!important;margin-bottom:12px!important}'+
      '.coa-bl h2{font-size:13px!important}'+
      '.coa-title-bar{padding:7px 10px!important;margin-bottom:12px!important}'+
      '.coa-title-bar h3{font-size:10px!important}'+
      '.coa-meta{grid-template-columns:1fr!important;margin-bottom:12px!important}'+
      '.coa-mi{padding:6px 10px!important}'+
      '.coa-ml{font-size:7px!important}'+
      '.coa-mv{font-size:10px!important}'+
      '.pur-disp{flex-direction:column!important;gap:8px!important;padding:10px 12px!important;overflow:visible!important}'+
      '.pur-big{flex-shrink:0!important;width:auto!important;text-align:center!important}'+
      '.pur-big .num{font-size:32px!important;line-height:1!important;white-space:nowrap!important;overflow:visible!important;letter-spacing:-.5px!important}'+
      '.pur-big .lbl{font-size:8px!important;white-space:nowrap!important;text-align:center!important}'+
      '.pur-bw{width:100%!important;min-width:0!important;overflow:visible!important}'+
      /* Reviews mobile */
      '.rev-doc{padding:16px!important;overflow:visible!important}'+
      '.rev-hdr{flex-direction:column!important;align-items:flex-start!important;gap:8px!important;padding-bottom:14px!important;margin-bottom:14px!important;overflow:visible!important}'+
      '.rev-hdr>div{overflow:visible!important;width:auto!important;max-width:100%!important}'+
      '.rev-big{font-size:30px!important;line-height:1.15!important;white-space:nowrap!important;overflow:visible!important;display:block!important}'+
      '.rev-name{font-size:13px!important}'+
      '.rev-list{max-height:220px!important;gap:9px!important;margin-bottom:18px!important}'+
      '.rev-item{padding:11px 12px!important}'+
      '.rev-author{font-size:11px!important}'+
      '.rev-text{font-size:11px!important}'+
      '.rev-star-pick{font-size:20px!important;gap:3px!important}'+
      '.pc-rating{font-size:9px!important;gap:4px!important;flex-wrap:wrap!important}'+
      '.pc-stars{font-size:10px!important}'+
      '.pur-bl{display:flex!important;justify-content:space-between!important;font-size:8px!important;gap:4px!important;flex-wrap:nowrap!important}'+
      '.pur-bl span{white-space:nowrap!important;overflow:visible!important}'+
      '.pur-st{font-size:7px!important;white-space:normal!important;overflow:visible!important}'+
      '.chromo-w{height:auto!important;padding:10px!important}'+
      '.chromo-w svg{height:auto!important;display:block!important}'+
      '.coa-res{margin-bottom:10px!important}'+
      '.coa-res h4{font-size:9px!important;margin-bottom:6px!important}'+
      '.coa-tbl-wrap{width:100%!important;overflow-x:auto!important;-webkit-overflow-scrolling:touch!important;margin:0!important;padding:0!important;box-sizing:border-box!important;display:block!important}'+
      '.coa-tbl{font-size:9px!important;width:100%!important;min-width:100%!important;display:table!important;white-space:normal!important;table-layout:fixed!important;border-collapse:collapse!important}'+
      '.coa-tbl th{font-size:8px!important;padding:7px 6px!important;word-break:break-word!important}'+
      '.coa-tbl td{font-size:8px!important;padding:7px 6px!important;word-break:break-word!important}'+
      '.coa-tbl th:nth-child(1),.coa-tbl td:nth-child(1){width:28%!important}'+
      '.coa-tbl th:nth-child(2),.coa-tbl td:nth-child(2){width:30%!important}'+
      '.coa-tbl th:nth-child(3),.coa-tbl td:nth-child(3){width:24%!important}'+
      '.coa-tbl th:nth-child(4),.coa-tbl td:nth-child(4){width:18%!important}'+
      '.coa-note{font-size:7px!important;padding:6px 10px!important}'+
      '.coa-sign{padding-top:6px!important;flex-wrap:wrap!important;gap:8px!important}'+
      /* Fluidité scroll mobile */
      'body{-webkit-overflow-scrolling:touch!important}'+
      '.cart-body,.chat-msgs,.modal{-webkit-overflow-scrolling:touch!important}'+
      '.pc{will-change:transform}'+
      '.btn-add,.btn-primary,.btn-outline{touch-action:manipulation!important}'+
      '.f-tag{touch-action:manipulation!important;-webkit-tap-highlight-color:transparent!important}'+
      /* COA scroll mobile amélioré */
      '.modal{overflow-y:auto!important;-webkit-overflow-scrolling:touch!important}'+
      '.pur-disp{box-sizing:border-box!important;width:100%!important}'+

      /* ── HEADER FIX MOBILE ── */
      'header{transform:translateZ(0)!important;-webkit-transform:translateZ(0)!important;will-change:transform!important;-webkit-backface-visibility:hidden!important}'+
      /* ── HERO ── */
      '.hero{padding:38px 16px 32px!important;min-height:0!important}'+
      '.hero-lbl{font-size:8px!important;padding:5px 14px!important;margin-bottom:16px!important}'+
      '.hero-title{font-size:clamp(19px,6vw,28px)!important;margin-bottom:12px!important}'+
      '.hero-sub{font-size:14px!important;margin-bottom:22px!important;padding:0 6px}'+
      '.hero-acts{flex-direction:column!important;align-items:center!important;gap:10px!important;margin-bottom:6px!important}'+
      '.hero-acts .btn-primary,.hero-acts .btn-outline{width:100%!important;max-width:280px!important;text-align:center!important;padding:14px 20px!important}'+
      '.stats-row{gap:0!important}'+
      '.stat{padding:12px 10px!important}'+
      '.stat-n{font-size:18px!important}'+
      '.stat-l{font-size:8px!important}'+

      /* ── TRUST BAND ── */
      '.trust{grid-template-columns:1fr 1fr!important;padding:16px 14px!important;gap:14px 8px!important}'+
      '.ti{gap:8px!important}'+
      '.t-ic{width:32px!important;height:32px!important}'+
      '.t-ic svg{width:14px!important;height:14px!important}'+
      '.t-num{font-size:14px!important;margin-bottom:1px!important}'+
      '.t-lbl{font-size:10px!important;margin-bottom:0!important}'+
      '.t-sub{font-size:8px!important}'+

      /* ── ACCESSOIRES (grille compacte 2 colonnes) ── */
      '.acc-grid{grid-template-columns:1fr 1fr!important;gap:8px!important;padding:0 14px 24px!important}'+
      '.acc-card{flex-direction:column!important;align-items:stretch!important;padding:10px!important;gap:0!important}'+
      '.acc-img{height:64px!important;width:100%!important;min-width:0!important;margin-bottom:6px!important}'+
      '.acc-n{font-size:10.5px!important;flex:none!important;min-width:0!important;line-height:1.15!important}'+
      '.acc-c{font-size:9px!important;flex:none!important;min-width:0!important}'+
      '.acc-stk{font-size:9px!important;margin-bottom:4px!important;flex:none!important;min-width:0!important}'+
      '.acc-foot{flex:none!important;flex-direction:row!important;align-items:center!important;justify-content:space-between!important;gap:6px!important;margin-top:4px!important}'+
      '.acc-p{font-size:13px!important;white-space:nowrap!important}'+
      '.btn-add-s{width:auto!important;padding:6px 10px!important;font-size:10px!important;white-space:nowrap!important}'+

      /* ── QUALITÉ ── */
      '.qual-sec{padding:40px 14px!important}'+
      '.q-in{grid-template-columns:1fr!important;gap:28px!important}'+
      '.q-right{grid-template-columns:1fr 1fr!important;gap:10px!important}'+
      '.qc{padding:14px 12px!important}'+
      '.qc-t{font-size:11px!important}'+
      '.qc-d{font-size:9px!important}'+
      '.q-metrics{margin-top:20px!important;gap:12px!important}'+

      /* ── NEWSLETTER ── */
      '.nl-sec{padding:44px 14px!important}'+
      '.nl-form{flex-direction:column!important;gap:8px!important}'+
      '.nl-inp{text-align:center!important}'+
      '.nl-form .btn-primary{width:100%!important}'+
      '.nl-in .s-title{font-size:20px!important}'+

      /* ── CONTACT ── */
      '.contact-sec{padding:40px 14px!important}'+
      '.contact-in{grid-template-columns:1fr!important;gap:24px!important}'+
      '.c-inp{font-size:13px!important;padding:12px!important}'+
      '.contact-in .btn-primary{width:100%!important;padding:13px!important}'+

      /* ── FOOTER (2 colonnes, marque en pleine largeur) ── */
      'footer{padding:36px 14px 80px!important}'+
      '.ft-main{grid-template-columns:1fr 1fr!important;gap:26px 16px!important}'+
      '.ft-main>div:first-child{grid-column:1/-1!important;margin-bottom:4px!important}'+
      '.ft-desc{max-width:100%!important}'+
      '.ft-ct{font-size:10px!important;margin-bottom:12px!important}'+
      '.ft-lnks{gap:10px!important}'+
      '.ft-lnks a{font-size:12px!important}'+
      '.ft-btm{flex-direction:column!important;gap:10px!important;text-align:center!important;padding-top:18px!important}'+
      '.ft-copy{font-size:10px!important}'+

      /* ── CHAT ── */
      '.chat-bubble{bottom:16px!important;right:14px!important}'+
      '.chat-msgs{max-height:180px!important}'+
      '.chat-inp{font-size:13px!important}'+

      /* ── FAQ ── */
      '.faq-sec{padding:40px 14px!important}'+
      '.faq-qt{font-size:12px!important}'+
      '.faq-a{font-size:11px!important}'+

      /* ── WHY ── */
      '.why-sec{padding:44px 14px!important}'+
      '.why-grid{grid-template-columns:1fr 1fr!important;gap:10px!important}'+
      '.why-c{padding:18px 14px!important}'+
      '.why-t{font-size:12px!important}'+
      '.why-d{font-size:10px!important}'+

      /* ── KITS (rangée compacte, même style que le reste du catalogue) ── */
      '.kit-card{flex-direction:row!important;align-items:stretch!important;gap:0!important;padding:0!important;overflow:hidden!important}'+
      '.kit-stage{aspect-ratio:auto!important;width:110px!important;min-width:110px!important;flex:none!important;height:auto!important}'+
      '.kit-trend{top:4px!important;right:4px!important;left:auto!important;font-size:7px!important;padding:3px 6px!important;gap:2px!important}'+
      '.kit-body{padding:10px!important;flex:1!important;min-width:0!important}'+
      '.kit-lbl{font-size:8px!important;margin-bottom:2px!important}'+
      '.kit-name{font-size:12px!important;line-height:1.2!important;margin-bottom:2px!important}'+
      '.kit-desc{display:none!important}'+
      '.kit-card .pc-rating{margin-bottom:4px!important}'+
      '.kit-card .stk-row{margin-bottom:6px!important}'+
      '.kit-card .stk-t{font-size:9px!important}'+
      '.kit-foot{flex-direction:row!important;align-items:center!important;justify-content:space-between!important;gap:6px!important}'+
      '.kit-price{font-size:15px!important}'+
      '.kit-cond{font-size:8px!important}'+
      '.kit-card .btn-primary{font-size:9px!important;padding:7px 10px!important;white-space:nowrap!important}'+

      /* ── SEC SEP ── */
      '.sec-sep{padding:28px 14px!important}'+
      '.sec-tb{flex-direction:column!important;align-items:flex-start!important;gap:6px!important;padding-bottom:4px!important}'+

      /* ── WISHLIST ── */
      '.wl-body{padding:10px 12px!important}'+

      /* ── COMPARE BAR ── */
      '.cmp-bar{padding:8px 12px!important;flex-wrap:wrap!important;gap:8px!important}'+
      '.cmp-slots{flex-wrap:nowrap!important;overflow-x:auto!important}'+
      '.cmp-slot{min-width:90px!important;font-size:8px!important}'+

    '}';
  var _mc=document.getElementById('nvxModernCss'); if(_mc&&_mc.parentNode){ _mc.parentNode.insertBefore(s,_mc); } else { document.head.appendChild(s); }
})();

/* ── KIT IMAGES ── */
(function(){

  document.addEventListener('DOMContentLoaded',function(){
    /* Kit cards now use real product photos (.kit-stage img) — the old .kit-ic SVG-fallback
       injection and its forced inline flex-direction:column!important have been removed since
       they no longer find any .kit-ic element and only served to block later layout CSS. */

    /* Shipping update */
    var shipIn=document.querySelector('#ship-sec .ship-in');
    if(shipIn){
      var desc=shipIn.querySelector('.s-desc');
      if(desc)desc.innerHTML='Chaque commande est préparée avec soin et expédiée sous <strong style="color:var(--tx)">24 heures ouvrées</strong> (du lundi au vendredi) via Colissimo. Nos colis sont conditionnés dans un emballage <strong style="color:var(--tx)">protecteur</strong>, garantissant l\'intégrité du produit.';
      var grid=shipIn.querySelector('.ship-grid');
      if(grid)grid.innerHTML='<div class="ship-card"><div class="ship-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><rect x="1" y="3" width="15" height="13"/><polygon points="16 8 20 8 23 11 23 16 16 16 16 8"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg></div><div style="flex:1"><div class="ship-zone">🇫🇷 France Métropolitaine</div><div class="ship-detail">Monaco &amp; Corse inclus<br><strong style="color:var(--tx)">Mondial Relay Point Relais :</strong> 3,89 € · <strong style="color:var(--tx)">Colissimo :</strong> dès 6,99 €<br><strong style="color:var(--tx)">Chronopost 18 :</strong> 12,97 € · <strong style="color:var(--tx)">Chrono 13 :</strong> 16,10 €<br><span style="font-size:9px;color:var(--m3)">Emballage protégé · Suivi fourni · Assuré</span></div></div><div class="ship-p">dès 3,89 €</div></div><div class="ship-card"><div class="ship-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 22s-8-4.5-8-11.8A8 8 0 0112 2a8 8 0 018 8.2c0 7.3-8 11.8-8 11.8z"/><circle cx="12" cy="10" r="3"/></svg></div><div style="flex:1"><div class="ship-zone">🌴 France Outre-Mer</div><div class="ship-detail">Guadeloupe, Martinique, Réunion, Guyane, Mayotte<br><strong style="color:var(--tx)">Colissimo Outre-Mer :</strong> 5-10 jours ouvrés<br><span style="font-size:9px;color:var(--m3)">Suivi fourni · Assuré · Chronopost Express 29,99 €</span></div></div><div class="ship-p">14,99 €</div></div><div class="ship-card"><div class="ship-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg></div><div style="flex:1"><div class="ship-zone">🇪🇺 Union Européenne</div><div class="ship-detail">Tous les pays de l\'UE<br><strong style="color:var(--tx)">Colissimo International :</strong> 4-8 jours ouvrés<br><span style="font-size:9px;color:var(--m3)">Suivi en temps réel · Emballage sécurisé · Assuré · Chronopost Express 20,09 €</span></div></div><div class="ship-p">14,99 €</div></div><div class="ship-card"><div class="ship-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="9"/><path d="M12 3v18M3 12h18"/></svg></div><div style="flex:1"><div class="ship-zone">🇬🇧🇨🇭 Royaume-Uni &amp; Suisse</div><div class="ship-detail"><strong style="color:var(--tx)">Colissimo International :</strong> 4-7 jours ouvrés<br><span style="font-size:9px;color:var(--m3)">Suivi en temps réel · Emballage sécurisé · Assuré · DHL Express 49,69 €</span></div></div><div class="ship-p">18,99 €</div></div><div class="ship-card"><div class="ship-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 014 10 15.3 15.3 0 01-4 10 15.3 15.3 0 01-4-10 15.3 15.3 0 014-10z"/></svg></div><div style="flex:1"><div class="ship-zone">🌍 Europe de l\'Est &amp; Maghreb</div><div class="ship-detail">Maroc, Algérie, Tunisie, Norvège, Balkans, Ukraine...<br><strong style="color:var(--tx)">Colissimo International :</strong> 6-12 jours ouvrés<br><span style="font-size:9px;color:var(--m3)">Suivi · Assuré</span></div></div><div class="ship-p">24,99 €</div></div><div class="ship-card"><div class="ship-ic"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 22s-8-4.5-8-11.8A8 8 0 0112 2a8 8 0 018 8.2c0 7.3-8 11.8-8 11.8z"/><circle cx="12" cy="10" r="3"/></svg></div><div style="flex:1"><div class="ship-zone">🌍 International</div><div class="ship-detail">Amériques, Asie, Océanie &amp; Afrique, Proche/Moyen-Orient<br><strong style="color:var(--tx)">Colissimo International :</strong> 5-12 jours ouvrés<br><span style="font-size:9px;color:var(--m3)">Suivi porte-à-porte · Assuré · DHL Express 68,48 € · États-Unis 47,99 €</span></div></div><div class="ship-p">34,99 €</div></div>';
    }

    /* Email on page */
    document.querySelectorAll('a[href*="novalyx.com"]').forEach(function(a){if(a.textContent.includes('@'))a.textContent=a.textContent.replace(/contact@novalyx\.com/g,'contact@novalyxlabs.fr');if(a.href.includes('mailto:contact@novalyx.com'))a.href='mailto:contact@novalyxlabs.fr';});
    document.querySelectorAll('*').forEach(function(el){if(!el.children.length&&el.textContent.includes('contact@novalyx.com'))el.textContent=el.textContent.replace(/contact@novalyx\.com/g,'contact@novalyxlabs.fr');});

    /* Me prévenir buttons */
    document.querySelectorAll('.btn-coa-s').forEach(function(btn){
      if(btn.textContent.includes('prévenir')||btn.textContent.includes('Alerte')){
        var card=btn.closest('.pc');
        var nameEl=card&&card.querySelector('.p-name');
        var name=nameEl?nameEl.textContent.trim():'ce produit';
        btn.onclick=function(){showAlertModal(name);};
      }
    });

    /* Init cart badge */
    fetchCart().then(function(c){if(c){var b=document.getElementById('cartBdg');if(b)b.textContent=c.item_count||0;}});

    /* Mettre à jour les liens footer */
    var footerLinks = {
      'À propos':                    '/pages/a-propos',
      'Politique de confidentialité':'/pages/politique-de-confidentialite',
      'Conditions générales':        '/pages/conditions-generales-de-vente',
      'Mentions légales':            '/pages/mentions-legales',
      'Politique de retour':         '/pages/politique-de-retour',
      'Guide de stockage':           '/pages/guide-de-stockage',
      'Documentation':               '/pages/guide-de-stockage'
    };
    document.querySelectorAll('footer a, .ft-links a').forEach(function(a){
      var txt = a.textContent.trim();
      if(footerLinks[txt]){
        a.href = footerLinks[txt];
      }
    });
  });
})();
/* ── FR/EN LANGUAGE TOGGLE ── */
var NVX_EN = {
  navLinks: ['Peptides','Packs','Accessories','Shipping','FAQ','Blog','Contact'],
  heroLbl: 'Certified purity · Shipped within 24h',
  heroTitle: 'NOVALYXLABS',
  heroSub: 'Research compounds, each batch supported by a certificate of analysis on request.',
  trust: ['Average Purity','Products with COA','Fast Shipping (business days)','Active References'],
  sEye: ['All-in-one','Premium Catalog','Consumables','Stay Informed'],
  sTitle: ['Packs','Our Research Peptides','Laboratory Accessories','Join NOVALYXLABS','Join NOVALYXLABS'],
  promoTxt: '🔥 <strong>-15%</strong> on the entire site — Code <span class="promo-bar-code">NVX15</span> — Until September 30',
  revVerified: '✓ Verified purchase',
  revCountSuffix: ' verified reviews',
  pSub: ['Mitochondria-derived peptide','Also in <a href="/products/pack-5-mg" onclick="event.stopPropagation()" style="color:var(--n1);font-weight:600;text-decoration:none">Pack 5 mg</a>','Also in <a href="/products/pack-10-mg" onclick="event.stopPropagation()" style="color:var(--n1);font-weight:600;text-decoration:none">Pack 10 mg</a>','Also in <a href="/products/pack-20-mg" onclick="event.stopPropagation()" style="color:var(--n1);font-weight:600;text-decoration:none">Pack 20 mg</a>','Also in <a href="/products/pack-30-mg" onclick="event.stopPropagation()" style="color:var(--n1);font-weight:600;text-decoration:none">Pack 30 mg</a>','Coenzyme','TB-500 + BPC-157 blend','CJC 1295 + Ipamorelin blend — 5 mg + 5 mg','Heptapeptide — Tuftsin analogue','Heptapeptide — ACTH/MSH analogue','Exclusive multi-peptide formula','α-MSH derived tripeptide','NNMT inhibitor','Synthetic GHRH analogue','Ghrelin receptor agonist','Copper tripeptide','Copper tripeptide — High concentration','GHK-Cu peptide analogue','α-MSH analogue'],
  kitName: ['Pack 5 mg','Pack 10 mg','Pack 20 mg','Pack 30 mg','GHK-Cu 50 mg Pack','GHK-Cu 100 mg Pack','Klow Blend 80 mg Pack'],
  kitDesc: [
    "Includes: 5 mg • Injection syringes 0.5ml (x5) • Reconstitution syringe 1ml • Bacteriostatic water 3ml",
    "Includes: 10 mg • Reconstitution syringe 1ml • 10 injection syringes 0.5ml • Bacteriostatic water • Disinfectant wipes",
    "Includes: 20 mg • Reconstitution syringe 3ml • 10 injection syringes 0.5ml • Bacteriostatic water • Disinfectant wipes",
    "Includes: 30 mg • Reconstitution syringe 3ml • 15 injection syringes 0.5ml • Bacteriostatic water • Disinfectant wipes",
    "Includes: GHK-Cu 50 mg • Reconstitution syringe 3ml • 20 injection syringes 0.5ml • Bacteriostatic water • Disinfectant wipes",
    "Includes: GHK-Cu 100 mg • Reconstitution syringe 3ml • 40 injection syringes 0.5ml • Bacteriostatic water • Disinfectant wipes",
    "Includes: Klow Blend 80 mg (GHK-Cu 50mg + TB-500 10mg + BPC-157 10mg + KPV 10mg) • Reconstitution syringe 3ml • 20 injection syringes 0.5ml • Bacteriostatic water • Disinfectant wipes"
  ],
  faqQ: ["Are NOVALYXLABS products intended for human consumption?","How are NOVALYXLABS peptides stored?","How do I access the certificates of analysis (COA)?","What are the delivery times and methods?","What payment methods do you accept?","How do I reconstitute a peptide with bacteriostatic water?"],
  faqA: [
    "No. All of our products are exclusively intended for scientific research in a laboratory setting. They are not approved for human or veterinary use. All information is provided for educational and research purposes only.",
    "Our peptides are delivered lyophilized in sterilized vials. Recommended storage: -20°C long term, 2°C to 8°C for short-term use (under 3 months). Avoid repeated freeze/thaw cycles.",
    "Each COA is accessible from the product page or the \"COA Certificates\" section. Reports are issued by Brown Biology Institute and include HPLC results, mass spectrometry and content verification.",
    "Mainland France: from €3.89 (Mondial Relay pickup point; Colissimo from €6.99) — 2-4 business days, tracked. French Overseas Territories (Guadeloupe, Martinique, Réunion, French Guiana, Mayotte): €14.99 — 5-10 business days. European Union: €14.99 — 4-8 business days. UK & Switzerland: €18.99 — 4-7 business days. International (Canada, Australia, Japan, South Korea, Malaysia, Hong Kong, Israel, New Zealand, UAE...): €34.99 — 5-12 business days. USA: €47.99. All orders ship within 24h (business days, Monday to Friday) in secure packaging with tracking number.",
    "You place your order on the site without paying straight away. A secure payment link (card, Apple Pay…) is emailed to you a few minutes later and stays valid for 30 minutes. Your order is prepared as soon as payment is received. If the link has expired, contact us and we will send you a new one.",
    "Reconstitution must be performed in a laboratory by a qualified researcher. Slowly introduce the bacteriostatic water against the wall of the lyophilized vial. Do not shake — swirl gently. Refrigerate after reconstitution, use within 28 days."
  ],
  ftCt: ['Catalog','Resources','Information'],
  ftDisc: 'Products exclusively intended for scientific research. Not intended for human or veterinary use. Information for educational purposes only.',
  placeholders: {
    'Rechercher un peptide...': 'Search a peptide...',
    'Votre avis...': 'Your review...',
    'Votre email': 'Your email',
    'Votre message...': 'Your message...',
    'Votre nom': 'Your name',
    'votre@laboratoire.com': 'your@laboratory.com',
    'Prénom': 'First name',
    'Nom': 'Last name',
    'Code promotionnel...': 'Promo code...'
  },
  buttons: {
    'Envoyer le message': 'Send message',
    "S'ABONNER →": 'SUBSCRIBE →',
    'RECEVOIR MON CODE -10% →': 'GET MY -10% CODE →',
    'Ajouter au panier': 'Add to cart',
    'Ajouter': 'Add',
    'Envoyer mon avis': 'Submit my review',
    '💬 Demander le COA': '💬 Request the COA'
  },
  stockPatterns: [
    [/^(\d+) unités disponibles$/, '$1 units available'],
    [/^(\d+) unités — Stock limité$/, '$1 units — Limited stock'],
    [/^Stock épuisé$/, 'Out of stock'],
    [/^Épuisé$/, 'Sold out']
  ]
};
var _nvxOrig = {};
function _nvxStore(sel){ if(!_nvxOrig[sel]){ _nvxOrig[sel] = Array.prototype.map.call(document.querySelectorAll(sel), function(e){return e.innerHTML;}); } return _nvxOrig[sel]; }
function _nvxSwap(sel, arr, orig){
  var els = document.querySelectorAll(sel);
  Array.prototype.forEach.call(els, function(el,i){
    if(orig){ if(orig[i]!==undefined) el.innerHTML = orig[i]; }
    else { if(arr[i]!==undefined) el.innerHTML = arr[i]; }
  });
}
function toggleLang(){
  var btn = document.getElementById('nvxLangBtn');
  var toEn = btn.textContent.trim()==='FR';
  if(toEn){
    _nvxStore('.hdr-nav a'); _nvxStore('.hero-lbl'); _nvxStore('.hero-title .gr'); _nvxStore('.hero-sub');
    _nvxStore('.t-lbl'); _nvxStore('.s-eye'); _nvxStore('.s-title'); _nvxStore('.p-sub');
    _nvxStore('.kit-name'); _nvxStore('.kit-desc'); _nvxStore('.faq-qt'); _nvxStore('.faq-a');
    _nvxStore('.ft-ct'); _nvxStore('.ft-disc');
    _nvxSwap('.hdr-nav a', NVX_EN.navLinks);
    _nvxSwap('.hero-lbl', [NVX_EN.heroLbl]);
    _nvxSwap('.hero-title .gr', [NVX_EN.heroTitle]);
    _nvxSwap('.hero-sub', [NVX_EN.heroSub]);
    _nvxSwap('.t-lbl', NVX_EN.trust);
    _nvxSwap('.s-eye', NVX_EN.sEye);
    _nvxSwap('.s-title', NVX_EN.sTitle);
    _nvxSwap('.p-sub', NVX_EN.pSub);
    _nvxSwap('.kit-name', NVX_EN.kitName);
    _nvxSwap('.kit-desc', NVX_EN.kitDesc);
    _nvxSwap('.faq-qt', NVX_EN.faqQ);
    _nvxSwap('.faq-a', NVX_EN.faqA);
    _nvxSwap('.ft-ct', NVX_EN.ftCt);
    _nvxSwap('.ft-disc', [NVX_EN.ftDisc]);
    if(!_nvxOrig['.promo-bar-txt']){ _nvxOrig['.promo-bar-txt'] = Array.prototype.map.call(document.querySelectorAll('.promo-bar-txt'), function(e){return e.innerHTML;}); }
    document.querySelectorAll('.promo-bar-txt').forEach(function(el){ el.innerHTML = NVX_EN.promoTxt; });
    if(!_nvxOrig['.rv-verified']){ _nvxOrig['.rv-verified'] = Array.prototype.map.call(document.querySelectorAll('.rv-verified'), function(e){return e.textContent;}); }
    document.querySelectorAll('.rv-verified').forEach(function(el){ el.textContent = NVX_EN.revVerified; });
    var _revAggCnt = document.getElementById('revAggCnt');
    if(_revAggCnt){
      if(!_nvxOrig['#revAggCnt']) _nvxOrig['#revAggCnt'] = _revAggCnt.textContent;
      var _m = _revAggCnt.textContent.match(/(\d+)/);
      if(_m) _revAggCnt.textContent = '— '+_m[1]+NVX_EN.revCountSuffix;
    }
    document.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function(el){
      var v = el.getAttribute('placeholder');
      if(NVX_EN.placeholders[v]) el.setAttribute('placeholder', NVX_EN.placeholders[v]);
    });
    document.querySelectorAll('button, a.btn-ghost').forEach(function(el){
      var t = el.textContent.trim();
      if(NVX_EN.buttons[t]) el.textContent = NVX_EN.buttons[t];
    });
    if(!_nvxOrig['.stk-t']){
      _nvxOrig['.stk-t'] = Array.prototype.map.call(document.querySelectorAll('.stk-t'), function(e){return e.textContent;});
    }
    document.querySelectorAll('.stk-t').forEach(function(el){
      var t = el.textContent.trim();
      for(var i=0;i<NVX_EN.stockPatterns.length;i++){
        if(NVX_EN.stockPatterns[i][0].test(t)){ el.textContent = t.replace(NVX_EN.stockPatterns[i][0], NVX_EN.stockPatterns[i][1]); break; }
      }
    });
    btn.textContent = 'EN';
    document.documentElement.setAttribute('lang','en');
    try{ localStorage.setItem('nvx_lang','en'); }catch(e){}
  } else {
    ['.hdr-nav a','.hero-lbl','.hero-title .gr','.hero-sub','.t-lbl','.s-eye','.s-title','.p-sub','.kit-name','.kit-desc','.faq-qt','.faq-a','.ft-ct','.ft-disc'].forEach(function(sel){
      _nvxSwap(sel, null, _nvxOrig[sel]);
    });
    if(_nvxOrig['.promo-bar-txt']){
      document.querySelectorAll('.promo-bar-txt').forEach(function(el,i){ if(_nvxOrig['.promo-bar-txt'][i]!==undefined) el.innerHTML = _nvxOrig['.promo-bar-txt'][i]; });
    }
    if(_nvxOrig['.rv-verified']){
      document.querySelectorAll('.rv-verified').forEach(function(el,i){ if(_nvxOrig['.rv-verified'][i]!==undefined) el.textContent = _nvxOrig['.rv-verified'][i]; });
    }
    if(_nvxOrig['#revAggCnt']){
      var _revAggCnt2 = document.getElementById('revAggCnt');
      if(_revAggCnt2) _revAggCnt2.textContent = _nvxOrig['#revAggCnt'];
    }
    if(_nvxOrig['.stk-t']){
      Array.prototype.forEach.call(document.querySelectorAll('.stk-t'), function(el,i){ el.textContent = _nvxOrig['.stk-t'][i]; });
    }
    document.querySelectorAll('input[placeholder], textarea[placeholder]').forEach(function(el){
      var v = el.getAttribute('placeholder');
      for(var k in NVX_EN.placeholders){ if(NVX_EN.placeholders[k]===v){ el.setAttribute('placeholder', k); break; } }
    });
    document.querySelectorAll('button, a.btn-ghost').forEach(function(el){
      var t = el.textContent.trim();
      for(var k in NVX_EN.buttons){ if(NVX_EN.buttons[k]===t){ el.textContent = k; break; } }
    });
    btn.textContent = 'FR';
    document.documentElement.setAttribute('lang','fr');
    try{ localStorage.setItem('nvx_lang','fr'); }catch(e){}
  }
}
(function(){
  try{
    if(localStorage.getItem('nvx_lang')==='en'){
      if(document.readyState==='loading'){
        document.addEventListener('DOMContentLoaded', toggleLang);
      } else {
        toggleLang();
      }
    }
  }catch(e){}
})();


/* ===== NVX : interface moderne (barre d'onglets, contact, héro) ===== */
(function(){
  function $(id){ return document.getElementById(id); }
  window.nvxSearch=function(){ var h=$('hdr'); if(!h)return; var o=h.classList.toggle('search-open'); if(o){ var i=$('srchInp'); if(i)setTimeout(function(){ i.focus(); },60); } };
  window.nvxContact=function(){ var o=$('nvxCt'),v=$('nvxCtOv'); if(!o)return; var op=!o.classList.contains('open'); o.classList.toggle('open',op); if(v)v.classList.toggle('open',op); };
  function esc(s){ return String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;'); }
  window.nvxHeroSplit=function(){
    var g=document.querySelector('.hero-title .gr'); if(!g||g.querySelector('.h1b'))return;
    var t=g.textContent.trim(), i=t.indexOf(','); if(i<0)return;
    g.innerHTML='<span class="h1a">'+esc(t.slice(0,i+1))+'</span><br><span class="h1b">'+esc(t.slice(i+1).trim())+'</span>';
  };
  window.nvxI18n=function(en){
    document.querySelectorAll('[data-en]').forEach(function(el){
      if(el.getAttribute('data-fr')===null) el.setAttribute('data-fr',el.textContent);
      el.textContent = en ? el.getAttribute('data-en') : el.getAttribute('data-fr');
    });
  };
  var _tl=window.toggleLang;
  if(typeof _tl==='function'){
    window.toggleLang=function(){ _tl(); var b=$('nvxLangBtn'); nvxI18n(b&&b.textContent.trim()==='EN'); nvxHeroSplit(); };
  }
  function fillHero(){
    var vis=document.querySelector('.hero2-vis'); if(!vis||vis.children.length)return;
    function find(sel,rx){ var els=document.querySelectorAll(sel); for(var i=0;i<els.length;i++){ if(rx.test(els[i].textContent)){ var c=els[i].closest('.kit-card,.pc'); var im=c&&c.querySelector('img'); if(im){ return im.getAttribute('src')||''; } } } return ''; }
    var a=find('.kit-name',/./), b=find('.p-name',/Klow/i), c=find('.p-name',/GHK-?Cu\s*50/i);
    var h=''; if(a)h+='<span class="v v1"><img src="'+a+'" alt="" fetchpriority="high"></span>'; if(b)h+='<span class="v v2"><img src="'+b+'" alt=""></span>'; if(c)h+='<span class="v v3"><img src="'+c+'" alt=""></span>';
    vis.innerHTML=h;
  }
  document.addEventListener('DOMContentLoaded',function(){
    fillHero();
    var lang=null; try{ lang=localStorage.getItem('nvx_lang'); }catch(e){}
    if(lang==='en'){ nvxI18n(true); }
    nvxHeroSplit();
    var cb=$('cartBdg'),tb=$('tabBdg');
    if(cb&&tb){ var mir=function(){ var n=parseInt(cb.textContent,10)||0; tb.textContent=n; tb.classList.toggle('has',n>0); }; mir(); new MutationObserver(mir).observe(cb,{childList:true,characterData:true,subtree:true}); }
    var h=$('hdr');
    if(h){ var set=function(){ document.documentElement.style.setProperty('--nvx-hdr',h.offsetHeight+'px'); }; var f=function(){ h.classList.toggle('is-scrolled',window.scrollY>30); set(); }; window.addEventListener('scroll',f,{passive:true}); window.addEventListener('resize',set); f(); }
    var tabs=document.querySelectorAll('#nvxTab [data-t]');
    if(tabs.length){
      var setT=function(k){ tabs.forEach(function(x){ x.classList.toggle('on',x.getAttribute('data-t')===k); }); };
      var home=(location.pathname==='/'||location.pathname==='');
      if(!home){ setT(location.pathname.indexOf('certificats')>-1?'coa':''); }
      else {
        var ids=[['kits-sec','packs'],['peptides','peps']];
        var g=function(){ var cur='home'; ids.forEach(function(p){ var e=$(p[0]); if(e&&e.getBoundingClientRect().top<window.innerHeight*0.45)cur=p[1]; }); var a=$('acc-sec'); if(a&&a.getBoundingClientRect().top<window.innerHeight*0.45)cur='peps'; setT(cur); };
        window.addEventListener('scroll',g,{passive:true}); g();
      }
    }
  });
})();

/* ── Paiement : checkout Shopify natif (moyen de paiement manuel) ── */
async function nvxGoCheckout(){
  var c=await fetchCart();
  if(!c||!c.item_count){toast('Panier vide');return;}
  var p=(typeof _nvxGateProof==='function')?_nvxGateProof():'';
  if(p){
    try{ await fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{'Attestation accès':p}})}); }catch(e){}
  }
  window.location.href='/checkout';
}
